import React from "react";
import { Provider } from "react-redux";

import store, { persistor } from "../../state/Store";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";

import { DisplayType } from "../../types/system/DisplayType";
import { CustomConfigSection } from "../../state/system/Menu";
import { MenuItem } from "../../types/system/MenuItem";
import Configuration from "../../foundation/Configuration";
import ApplicationState from "../../foundation/AppState";
import Main from "../main/Main";

import "./App.scss";

import "../../foundation/JSON";
import "../../foundation/DateExtensions";
import "../../foundation/NumberExtensions";
import "../../foundation/ArrayExtensions";
import "../../foundation/StringExtensions";
import "../../foundation/UrlExtensions";
import "../../foundation/BlobExtensions";
import "../../foundation/FileExtensions";
import "../../foundation/StreamExtensions";
import "../../foundation/ElementExtensions";

interface AppProps {
    menuItems: MenuItem[];
    generalSettings: MenuItem[];
    configSettings: MenuItem[];
    customSections: CustomConfigSection[];
    displaySettings: DisplayType[];
    appLogo: string;
    flatLogo: string;
}

class App extends React.Component<AppProps> {
    state = {};

    constructor(props: AppProps) {
        super(props);

        document.title = Configuration.friendlyName;
        ApplicationState.instance.addMenuItems(props.menuItems);
        ApplicationState.instance.addGeneralItems(props.generalSettings);
        ApplicationState.instance.addConfigItems(props.configSettings);
        ApplicationState.instance.addCustomSections(props.customSections);
        ApplicationState.instance.addDisplayTypes(props.displaySettings);
    }

    render(): React.ReactNode {
        return (
            <Provider store={store}>
                <PersistGate
                    loading={null}
                    persistor={persistor}>
                    <BrowserRouter>
                        <Main
                            appLogo={this.props.appLogo}
                            flatLogo={this.props.flatLogo}
                        />
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        );
    }
}

export default App;
